import { render, staticRenderFns } from "./_OptionItems.vue?vue&type=template&id=38fc539c&scoped=true&"
import script from "./_OptionItems.vue?vue&type=script&lang=js&"
export * from "./_OptionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc539c",
  null
  
)

export default component.exports